module.exports = __webpack_public_path__ + "media/images/icons/flags/ER-641b9b7f38780556e71bce7629c4da24.svg";